<template>
  <div class="ads-wrap">
    <div class="search-group">
      <el-select
        v-model="filterData.permissionStatus"
        filterable
        placeholder="授权状态"
        style="width: 260px"
        @change="searchData"
      >
        <el-option label="全部授权状态" :value="null"></el-option>
        <el-option label="失败" :value="0"></el-option>
        <el-option label="成功" :value="1"></el-option>
      </el-select>
      <el-input
        placeholder="请输入名称或ID"
        v-model="filterData.search"
        style="width: 260px; margin-left: 16px"
        suffix-icon="el-icon-search"
        @input="searchData"
      ></el-input>
    </div>
    <div class="table-group">
      <div class="table-action">
        <el-button type="primary" icon="el-icon-plus" @click="addAdCount"
          >添加广告投放账号</el-button
        >
        <el-button class="pl-btn" @click="batchOpertion">批量解绑</el-button>
      </div>
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        ref="account"
        height="calc(100vh - 340px)"
        style="width: 100%"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="advertiserId" label="账户ID"> </el-table-column>
        <el-table-column prop="advertiserName" label="广告账户名称"> </el-table-column>
        <el-table-column prop="accountName" label="所属人员"> </el-table-column>
        <el-table-column prop="managerName" label="MCC"> </el-table-column>
        <el-table-column prop="permissionStatus" label="授权状态">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.permissionStatus == 1">
                <i class="el-icon-check" style="color: rgba(30, 194, 56, 1); cursor: pointer"></i>
                成功
              </span>
              <span v-if="scope.row.permissionStatus == 0">
                <i class="el-icon-warning-outline" style="color: rgba(234, 49, 49, 1)"></i>
                失败
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="modifyTime" label="授权时间"> </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" slot="reference" @click="unbundleOption(scope.row)"
              >解绑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        @getCurrentPage="getCurrentPage"
        ref="tabelPagination"
        @handleSizeChange="getCurrentSize"
      ></self-pagination>
    </div>
    <select-authorize-account
      ref="selectAccountModal"
      @successCallBack="resetData"
    ></select-authorize-account>
  </div>
</template>

<script>
import SelectAuthorizeAccount from "./selectAuthorizeAccount";
import launchServer from "@/api/account-management";
import { unBindGoogleAccount, getGoogleAccountAuthurl } from "@/api/promotion-google";

export default {
  components: {
    SelectAuthorizeAccount,
  },

  data() {
    return {
      filterData: {
        permissionStatus: null,
        search: "",
      },
      selectOption: [],
      showPlBox: false,
      tableData: [],
      pageData: {
        size: 10,
        page: 1,
        total: 10,
      },
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.searchData();
    if (this.$route.query.accountId) {
      this.$refs.selectAccountModal.showModal();
    }
  },

  methods: {
    searchData() {
      launchServer
        .getAdvertiserInfo({
          permissionStatus: this.filterData.permissionStatus,
          search: this.filterData.search,
          size: this.pageData.size,
          page: this.pageData.page,
          platType: 5,
        })
        .then((res) => {
          if (res.code === "0000") {
            this.tableData = res.advertiseInfos || [];
            this.pageData.total = res.totalCount;
          }
        });
    },
    handleSelectionChange(e) {
      this.selectOption = e;
    },
    getCurrentPage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    getCurrentSize (size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    resetData() {
      this.filterData = {
        permissionStatus: null,
        search: "",
      };
      this.getCurrentPage(1);
    },
    addAdCount() {
      getGoogleAccountAuthurl().then((res) => {
        window.open(res.data);
      });
    },
    batchOpertion() {
      if (this.selectOption.length === 0) {
        this.$message.warning("请至少选择一个账户");
      } else {
        unBindGoogleAccount(this.selectOption.map((item) => item.id)).then((res) => {
          if (res.code === "0000") {
            this.getCurrentPage(1);
            this.$message.success("解绑成功");
          }
        });
      }
    },
    unbundleOption(row) {
      unBindGoogleAccount([row.id]).then((res) => {
        if (res.code === "0000") {
          this.getCurrentPage(1);
          this.$message.success("解绑成功");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.table-group {
  .table-action {
    display: flex;
    align-items: center;
    padding: 9px 0px;
    width: 100%;
    height: 45px;
    .pl-btn {
      .plIcon {
        margin-right: 4px;
      }
      border: 1px solid #1890ff;
      color: #1890ff;
    }
  }
}
</style>
